import { render, staticRenderFns } from "./ArticleBase.vue?vue&type=template&id=1ab6d971"
import script from "./ArticleBase.vue?vue&type=script&lang=js"
export * from "./ArticleBase.vue?vue&type=script&lang=js"
import style0 from "./ArticleBase.vue?vue&type=style&index=0&id=1ab6d971&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports